const FranchiseDashboardRoute    = "/franchise-dashboard";
const ClubManagerDashboardRoute  = "/club-manager-dashboard";
const CustomerServiceDashboardRoute = "/customer-service-dashboard";
const SalesDashboardRoute        = "/sales-dashboard";
const AllFeedbacksRoute = "/all-feedback";
const AllDepartmentsRoute = "/all-departments";
const AddDepartmentRoute = "/add-department";
const AddCouponRoute = "/add-coupon"
const AllCouponsRoute = "/all-coupons"
const ComplimentaryCouponHistoryRoute = "/complimentary-coupon-history"
const CouponsRoute = "/coupons"
const CouponsHistoryRoute = "/coupons-history"
const CouponsSummaryRoute = "/coupons-summary"
const AllLockersRoute = "/all-lockers"
const AddLockerRoute = "/add-locker"
const AddBiometricRoute = "/add-biometric"
const AllBiometricsRoute = "/all-biometrics"
const Home = "/"
const AddUserRoute = "/add-user"
const EditUserRoute = "/edit-user"
const EditEmployeeRoute = "/edit-employee"
const EditGeneralStaffRoute = "/edit-general-staff"
const EditTrainerRoute = "/edit-trainer"
const AddEmployeeRoute = "/add-employee"
const AllEmployeesRoute = "/all-employees"
const WalletRoute = "/wallet"
const WalletTransactionsRoute = "/wallet-transactions"
const AllVendorsRoute = "/all-vendors"
const AllMerchantRoute = "/all-merchant"
const VendorTransactionsRoute = "/vendor-transactions"
const ExpenseHistoryRoute = "/expense-history"
const AddExpenseRoute = "/add-expense"
const EditExpenseRoute = "/edit-expense"
const AddCashRoute = "/add-cash"
const BankDepositRoute = "/bank-deposit"
const CashHistoryRoute = "/cash-history"
const AddBankRoute = "/add-bank"
const AllBankRoute = "/all-bank"
const BankDepositHistoryRoute = "/bank-deposit-history"
const DepositHistoryRoute = "/deposit-history"
const CashReportsRoute = "/cash-reports"
const HandoverRoute = "/handover"
const AllGeneralStaffRoute = "/all-general-staff"
const AddGeneralStaffRoute = "/add-general-staff"
const AllTrainersRoute = "/all-trainers"
const AddTrainerRoute = "/add-trainer"
const AllRolesRoute = "/all-roles"
const AddRoleRoute = "/add-role"
const AllDirectorsRoute = "/all-directors"
const AddDirectorRoute = "/add-director"
const EditDirectorRoute = "/edit-director"
const AllPackagesRoute = "/all-packages"
const AddPackageRoute = "/add-package"
const EditPackageRoute = "/edit-package"
const AllAddOnSlotsRoute = "/all-add-on-slots"
const AddAddOnSlotRoute = "/add-add-on-slot"
const userFeedbackRoute = "/user-feedback"
const userCallingFeedbackRoute = "/user-calling-feedback"

const AllBranchesRoute = "/all-branches"
const AddBranchRoute = "/add-branch"
const EditBranchRoute = "/edit-branch"
const CreditNoteRoute = "/credit-note"

const AllAddOnPackagesRoute = "/all-add-on-packages"
const AddAddOnPackageRoute = "/add-add-on-package"
const EditAddOnPackageRoute = "/edit-add-on-package"

const AllInventoryRoute = "/all-inventory"
const AddInventoryRoute = "/add-inventory"

// Invoice Management Routes
const AllInvoiceRoute = "/all-invoice"
const AddInvoiceRoute = "/add-invoice"
const EditInvoiceRoute = "/edit-invoice"
const PartialInvoiceRoute = "/partial-invoice"
const InvoiceDetailRoute = "/invoice-detail"
const AddOnSessionDetailRoute = "/add-on-session-detail"
const AddOnLiveDashboardRoute = "/add-on-live-dashboard"
const AddonIncentiveRoute = "/addon-incentive"
const WalkInIncomingRoute = "/walk-in-incoming"
const AddWalkInRoute = "/add-walk-in"
const ClientsRoute = "/clients"
const ClientSettingsRoute = "/clients/settings"
const ContentRoute = "/lead-content"
const LeadTeamRoute = "/lead-team"
const SubteamDetailRoute = "/lead-team/subteams"
const CreatePageRoute = "/lead-content/create-page"
const ClientDetailRoute = "/client-detail"
const ConvertLeadRoute = "/convert-lead"
const LeadActivityRoute = "/lead-activity"
const BlacklistRequestsRoute = "/blacklist-users"

const EmployeeDetailRoute = "/employee-detail"
const DirectorAttendanceRoute = "/director-attendance"
const UserAttendanceRoute = "/user-attendance"
const EmployeeAttendanceRoute = "/employee-attendance"
const TrainerAttendanceRoute = "/trainer-attendance"
const GeneralStaffAttendanceRoute = "/general-staff-attendance"
const FloorAttendanceRoute = "/floor-attendance"
const AttendanceDetailRoute = "/attendance-detail"
const ViewFormRoute = "/view-form"
const loginRoute = "/login"
const forgotPasswordRoute = "/forgot-password"
const AllUsersRoute = "/all-users"
const AllAddOnsUsersRoute = "/all-add-ons-users"
const UserAssessmentRoute = "/user-assessment"
const AssessmentBatteryRoute = "/assessment-battery"
const AllMembershipUsersRoute = "/all-membership-users"
const AllSessionsRoute = "/all-sessions"

// Employee Detail Routes
const EmployeeDetailAttendanceRoute = "/attendance"
const EmployeeDetailEmployeeIdRoute = "/employee-id"
const EmployeeDetailSalaryRoute = "/salary"
const EmployeeDetailSalesHistoryRoute = "/sales-history"
const UserDetailMembershipDaysRoute = "/membership-days";
const EmployeeDetailParkingHistoryRoute = "/parking-history"
const EmployeeDetailBiometricAccessRoute = "/biometric-access"
const EmployeeDetailAddBiometricAccessRoute = "/add-biometric-access"
const EmployeeDetailIncentiveRoute = "/incentive-calculation"
const EmployeeDetailIncentiveHistoryRoute = "/incentive-history"

// Employee Detail Sub-routes Menu

// General Staff Detail Routes
const GeneralStaffDetailRoute = "/general-staff-detail"
const GeneralStaffDetailAttendanceRoute = "/attendance"
const GeneralStaffDetailIdRoute = "/general-staff-id"
const GeneralStaffDetailSalaryRoute = "/salary"
const GeneralStaffDetailBiometricAccessRoute = "/biometric-access"
const GeneralStaffDetailAddBiometricAccessRoute = "/add-biometric-access"


// User Detail Tab Routes
const UserDetailRoute = "/user-detail";
const UserDetailAttendanceRoute = "/attendance";
const UserDetailMemberIdRoute = "/member-id";
const UserDetailMembershipRoute = "/membership";
const UserDetailMembershipFreezabilityRoute = "/membership-freezability";
const UserDetailAddonPackageRoute = "/addon-package";
const UserDetailAssessmentRoute = "/assessment";
const UserDetailRefundHistoryRoute = "/refund-history";
const UserDetailParkingHistoryRoute = "/parking-history";
const UserDetailDietsPlanRoute = "/diets-plan";
const UserDetailBiometricAccessRoute = "/biometric-access";

// Trainer Detail Routes
const TrainerDetailRoute = "/trainer-detail"
const TrainerDetailAttendanceRoute = "/attendance"
const TrainerDetailCoachIdRoute = "/coach-id"
const TrainerDetailClassesRoute = "/classes"
const TrainerDetailTransactionsRoute = "/transactions"
const TrainerDetailParkingHistoryRoute = "/parking-history"
const TrainerDetailBiometricAccessRoute = "/biometric-access"
const TrainerDetailAddBiometricAccessRoute = "/add-biometric-access"
const TrainerDetailIncentiveRoute = "/incentive-calculation"
const TrainerDetailIncentiveHistoryRoute = "/incentive-history"

// director Detail Routes
const DirectorDetailPageRoute = "/director-detail"
const DirectorAttendancePageRoute = "/attendance"

const DirectorBiometricAccessPageRoute = "/biometric-access"
const EditRoleRoute = "/edit-role"

export {EditDirectorRoute, EditRoleRoute, Home, AddUserRoute, EditUserRoute, EditEmployeeRoute, EditGeneralStaffRoute, EditTrainerRoute, AddEmployeeRoute,
     AllEmployeesRoute, AllGeneralStaffRoute, AddGeneralStaffRoute, 
     AllTrainersRoute, AddTrainerRoute, AllRolesRoute, AddRoleRoute, 
     AllDirectorsRoute, AddDirectorRoute, AllPackagesRoute, AddPackageRoute, EditPackageRoute, AllAddOnSlotsRoute,
      AddAddOnSlotRoute, AllAddOnPackagesRoute, AddAddOnPackageRoute, EditAddOnPackageRoute, AllUsersRoute, AllAddOnsUsersRoute,
       DirectorAttendanceRoute, UserAttendanceRoute, EmployeeAttendanceRoute, TrainerAttendanceRoute, GeneralStaffAttendanceRoute, FloorAttendanceRoute, AttendanceDetailRoute, ViewFormRoute, loginRoute, EmployeeDetailRoute,
        EmployeeDetailAttendanceRoute, EmployeeDetailEmployeeIdRoute,
         EmployeeDetailSalaryRoute, EmployeeDetailSalesHistoryRoute, 
         EmployeeDetailParkingHistoryRoute, EmployeeDetailBiometricAccessRoute,
          EmployeeDetailAddBiometricAccessRoute,
          EmployeeDetailIncentiveRoute, EmployeeDetailIncentiveHistoryRoute,
GeneralStaffDetailRoute, GeneralStaffDetailAttendanceRoute,
 GeneralStaffDetailIdRoute, GeneralStaffDetailSalaryRoute, GeneralStaffDetailBiometricAccessRoute,GeneralStaffDetailAddBiometricAccessRoute,
TrainerDetailRoute, TrainerDetailAttendanceRoute, TrainerDetailCoachIdRoute, TrainerDetailClassesRoute,
 TrainerDetailTransactionsRoute, TrainerDetailParkingHistoryRoute, 
 TrainerDetailBiometricAccessRoute, TrainerDetailAddBiometricAccessRoute, TrainerDetailIncentiveRoute, TrainerDetailIncentiveHistoryRoute,
 UserDetailAttendanceRoute, UserDetailMemberIdRoute, UserDetailMembershipRoute, UserDetailAddonPackageRoute,
  UserDetailAssessmentRoute, UserDetailRefundHistoryRoute,
   UserDetailParkingHistoryRoute, UserDetailDietsPlanRoute,
    UserDetailBiometricAccessRoute,
    UserDetailRoute,
    AllBranchesRoute, AddBranchRoute, EditBranchRoute, CreditNoteRoute,
    UserDetailMembershipFreezabilityRoute,
    UserDetailMembershipDaysRoute,
    DirectorDetailPageRoute,
   DirectorAttendancePageRoute,
   DirectorBiometricAccessPageRoute,
  AllCouponsRoute,
  ComplimentaryCouponHistoryRoute,
  CouponsRoute,
  CouponsHistoryRoute,
  CouponsSummaryRoute,
  AllLockersRoute,
  AddLockerRoute,
  AddCouponRoute,
  AllFeedbacksRoute,
  AllDepartmentsRoute,
  AddDepartmentRoute,
  userFeedbackRoute,
  userCallingFeedbackRoute,
  AllInventoryRoute,
  AddInventoryRoute,
  AddBiometricRoute,
  AllBiometricsRoute,
  AllInvoiceRoute,
  AddInvoiceRoute,
  EditInvoiceRoute,
  PartialInvoiceRoute,
  InvoiceDetailRoute,
  AddOnSessionDetailRoute,
  AddOnLiveDashboardRoute,
  AddonIncentiveRoute,
  WalkInIncomingRoute,
  AddWalkInRoute,
  ClientsRoute,
  ClientSettingsRoute,
  ContentRoute,
  LeadTeamRoute,
  SubteamDetailRoute,
  CreatePageRoute,
  ClientDetailRoute,
  ConvertLeadRoute,
  AllMembershipUsersRoute,
  AllSessionsRoute,
  UserAssessmentRoute,
  AssessmentBatteryRoute,
  forgotPasswordRoute,
  LeadActivityRoute,
  BlacklistRequestsRoute,
  FranchiseDashboardRoute,
  ClubManagerDashboardRoute,
  CustomerServiceDashboardRoute,
  SalesDashboardRoute,
  WalletRoute,
  WalletTransactionsRoute,
  AllVendorsRoute,
  AllMerchantRoute,
  VendorTransactionsRoute,
  ExpenseHistoryRoute,
  AddExpenseRoute,
  EditExpenseRoute,
  AddCashRoute,
  BankDepositRoute,
  CashHistoryRoute,
  AddBankRoute,
  AllBankRoute,
  BankDepositHistoryRoute,
  DepositHistoryRoute,
  CashReportsRoute,
  HandoverRoute,
 }